/// <reference path="../app.js"/>

class Resources {

	static pushState(category, resource = null) {
		window.history.pushState(null, "Resource » Cobb", "/resource/" + category + (resource !== null ? "/" + resource : "") + location.hash + location.search);
	}

	static getActiveCategory() {
        if ($('.cat-tabs').hasClass('non-english')) {
            if ($(".cat-tab.active").first().data("cat")) {
                return $(".cat-tab.active").first().data("cat") || "search";
            } else {
                return 'product-supplements';
            }
        } else {
            return $(".cat-tab.active").first().data("cat") || "search";
        }
	}

	static init() {

		this.bindUIActions();

        if ($('body').hasClass("ResourcesPage")) {
            var catFilter = Resources.getActiveCategory();

    		if (catFilter.length > 0)
    			$('.cat-tab[data-cat="'+catFilter+'"]').trigger('click');
    		else {
    			$('.featured-resources-grid').removeClass('hide');
    		}
        }

		function doSelectResource() {
			var selectResource = $(".grid-container[data-select-resource]").data("select-resource");

			if ($(".grid-container[data-select-resource]").length > 0)
				$('.resource-tile[data-slug="' + selectResource + '"]').first().trigger("click");
		}

		if (typeof YT.Player === "undefined") {
			window.onYouTubeIframeAPIReady = () => doSelectResource();
		}
		else doSelectResource();
	}

    static bindUIActions() {

        $(document).on('click', '.cat-tab', function() {
            var self = $(this);
			var cat = self.data('cat');

			Resources.pushState(cat);

            $('.cat-tab').removeClass('active');
            self.addClass('active');
            $('#product-guide-filters').addClass('hide');
            $('.product-guides-cell').addClass('hide');
            $('.resource-cell').addClass('hide');
            $('.all-resources-grid').removeClass('hide');
            $('.featured-resources-grid').addClass('hide');

            switch (cat) {
                case 'product-supplements':
                    $('.management-guides-resource-cell').addClass('hide');
                    $('.articles-resource-cell').addClass('hide');
                    $('#product-guide-filters').removeClass('hide');
                    $('.product-guides-cell').removeClass('hide');
                    $('.button','#product-guide-filters').addClass('light');
                    $('.button','#product-guide-filters').first().removeClass('light');
                    break;
                case 'featured':
                    $('.featured-resources-grid').removeClass('hide');
                    $('.all-resources-grid').addClass('hide');
                    $('.articles-resource-cell').removeClass('hide');
                    $('.videos-resource-cell').removeClass('hide');
                    $('.management-guides-resource-cell:not(.hero-guide)').removeClass('hide');
                    $('.posters-resource-cell').removeClass('hide');
                    $('.product-resource-cell.featured').removeClass('hide');
                    break;
                default:
                $('.'+cat+'-resource-cell').removeClass('hide');
            }
        });

        // $(document).on('keyup', '#search-field', function() {
        //     var search = $(this).val();
        //     if (search.length > 2) {
        //         console.log(search);
        //     }
        // });

        $('#product-guide-filters').on('click', '.button', function() {
            var self = $(this);
            var id = self.data('product');

            $('.button','#product-guide-filters').addClass('light');
            self.removeClass('light');

            if (id) {
                $('.product-guides-cell').addClass('hide');
                $('.product-'+id).removeClass('hide');
            } else {
                $('.product-guides-cell').removeClass('hide');
            }

        });

        $(document).on("closed.zf.reveal", "#video-embed", function() {
			var cat = Resources.getActiveCategory();

			$(this).find('.video-wrap').html("");

            if ($('body').hasClass("ResourcesPage")) {
                Resources.pushState(cat);
            }
		});

        function onPlayerReady(e) {
            // console.log("Player Ready");
            var player = YT.get('youtube-player');
            player.playVideo();
        }

        function pushProgress(p,t,v) {
            // console.log('progress:'+p);
            // console.log('time:'+t);
            // console.log(v);
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                'event': 'gtm.video',
                'gtm.videoProvider': 'Vimeo',
                'gtm.videoStatus': 'progress-'+p,
                'gtm.videoUrl': v.Url,
                'gtm.videoTitle': v.Title,
                'gtm.videoDuration': v.Duration,
                'gtm.videoCurrentTime': t,
                'gtm.videoVisible': true,
            });
        }

        $(document).on('click', '.video-resource-tile', function() {

            var id = $(this).data('video');
            var type = $(this).data('video-type');
            var modal = $('#video-embed');
            var ytPlayer;

            if (type == 'vimeo') {
                var embed = '<iframe id="vimeo-player" width="800" height="500" src="https://player.vimeo.com/video/'+ id +'?autoplay=1&api=1&player_id=vimeo-player" frameborder="0" allow="autoplay; fullscreen" webkitAllowFullScreen mozallowfullscreen allowFullScreen></iframe>';
                // populate and open video modal
                modal.find('.video-wrap').html(embed);

                var iframe = $('#vimeo-player')[0];
                var player = new Vimeo.Player(iframe);
                var vidTitle,
                    vidUrl,
                    vidDuration,
                    quarterComplete = false,
                    halfComplete = false,
                    threeQuarterComplete = false;

                player.on('play', function(data) {
                    var time = Math.round(data.seconds);
                    window.dataLayer = window.dataLayer || [];
                    window.dataLayer.push({
                        'event': 'gtm.video',
                        'gtm.videoProvider': 'Vimeo',
                        'gtm.videoStatus': 'start-'+time,
                        'gtm.videoUrl': vidUrl,
                        'gtm.videoTitle': vidTitle,
                        'gtm.videoDuration': vidDuration,
                        'gtm.videoCurrentTime': time,
                        'gtm.videoVisible': true,
                    });

                });

                player.getVideoTitle().then(function(title) {
                    vidTitle = title;
                });
                player.getVideoUrl().then(function(url) {
                    vidUrl = url;
                });
                player.getDuration().then(function(d) {
                    vidDuration = d;
                });

                player.on('pause', function(data) {
                    var time = Math.round(data.seconds);
                    window.dataLayer = window.dataLayer || [];
                    window.dataLayer.push({
                        'event': 'gtm.video',
                        'gtm.videoProvider': 'Vimeo',
                        'gtm.videoStatus': 'pause-'+time,
                        'gtm.videoUrl': vidUrl,
                        'gtm.videoTitle': vidTitle,
                        'gtm.videoDuration': vidDuration,
                        'gtm.videoCurrentTime': time,
                        'gtm.videoVisible': true,
                    });
                });

                player.on('ended', function(data) {
                    var v = {Title:vidTitle, Duration:vidDuration, Url: vidUrl};
                    pushProgress('100',vidDuration,v);
                });

                player.on('timeupdate', function(data) {
                    var progress = Math.round(data.percent*100);
                    var t = Math.round(data.seconds);
                    var v = {Title:vidTitle, Duration:vidDuration, Url: vidUrl};
                    switch (progress) {
                        case 25:
                            if (!quarterComplete) {pushProgress('25',t,v); quarterComplete=true;};
                            break;
                        case 50:
                            if (!halfComplete) {pushProgress('50',t,v); halfComplete=true;};
                            break;
                        case 75:
                            if (!threeQuarterComplete) {pushProgress('75',t,v); threeQuarterComplete=true;};
                            break;
                        default:

                    }
                });

            } else if (type == 'youtube') {
                var embed = '<iframe id="youtube-player" width="560" height="315" src="https://www.youtube.com/embed/'+id+'?enablejsapi=1" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>';

                // populate and open video modal
                modal.find('.video-wrap').html(embed);

				try {
					// init yt player api
					ytPlayer = new YT.Player('youtube-player', {
						events: {
							'onReady': onPlayerReady
						}
					});
				}
				catch {
					console.error("Failed to initalize Youtube API");
				}
            }

            modal.foundation('open');
            // window.__vimeoRefresh()

            if ($('body').hasClass("ResourcesPage")) {
                Resources.pushState(Resources.getActiveCategory(), $(this).data("slug"));
            }

        });

    }
}
